import React, { FunctionComponent } from 'react';
import Events from '../events/events';
import Holidays from '../holidays/holidays';

type ExceptionsProps = {
  selectedTerminal: string;
};

const Exceptions: FunctionComponent<ExceptionsProps> = ({ selectedTerminal }) => {
  return (
    <div className="Exceptions">
      <h2 className="Exceptions__title">Exceptions {new Date().getFullYear()}</h2>
      <Holidays selectedTerminal={selectedTerminal} gateMode />
      <br />
      <Events selectedTerminal={selectedTerminal} gateMode />
    </div>
  );
};

export default Exceptions;
